import type { AccountInfo } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { router } from './router.tsx';
import { TanStackAppDevtools } from './tanstack-devtools.tsx';

export function InnerApp() {
  const { instance, accounts } = useMsal();
  const [account, setAccount] = useState<AccountInfo>();

  useEffect(() => {
    if (accounts.length > 0 && accounts[0]) {
      instance.setActiveAccount(accounts[0]);
      // eslint-disable-next-line react-hooks-extra/no-direct-set-state-in-use-effect
      setAccount(accounts[0]);
    }
  }, [accounts, instance]);

  // NOTE(OLA):
  // Msal useAccount() doesn't trigger rerenders.
  // Temp hack setting key here instead.
  return (
    <>
      <RouterProvider router={router} key={account?.username} />
      <TanStackAppDevtools />
    </>
  );
}
